import React from 'react';
import { Icon } from '../Icon/Icon';

function Download(_a) {
  var children = _a.children,
      href = _a.href,
      target = _a.target;
  return React.createElement("a", {
    href: href,
    download: true,
    target: target
  }, React.createElement(Icon, {
    name: "download"
  }), children);
}

export default Download;